<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >

        <div :class="$style.map">
            <el-steps  :active="active" finish-status="success" align-center>
                <el-step title="搜索门店名称"></el-step>
                <el-step title="选择门店，填写门店基本信息"></el-step>
                <el-step title="保存"></el-step>
            </el-steps>
            <div class="search-body">
                <div class="amap-page-container">
                    <div class="search-box" v-if="showSearch">
                        <input type="search" class="search-input" id="search" v-model="searchKey" @keyup.enter="handleSearch">
                        <button @click="handleSearch">搜索</button>
                        <div class="tip-box" id="searchTip"></div>
                    </div>

                    <!--<el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult">-->

                    <!--</el-amap-search-box>-->

                    <el-amap
                            vid="amapDemo"
                            :center="center"
                            :zoom="zoom"
                            :amapManager="amapManager"
                            class="amap-demo"
                            :plugin="plugin">
                        <el-amap-marker
                                :position="center" :draggable="true" :events="edit_markers.events">
                        </el-amap-marker>
                    </el-amap>


                    <!--<div align="center" style="width: 100%">-->
                        <!--<span>拖拽移动图标进行编辑</span>-->
                    <!--</div>-->
                </div>
                <ul>
                    <li v-for="item in result" :key="item.id">{{item.name}}</li>
                </ul>
            </div>
        </div>
        <el-row v-show="active === 2">
            <el-col :span="24" class="subjectList">
                <div :class="$style.top">
                    <el-form ref="form" :model="form" label-width="120px" :disabled="!isAdmin">
                        <el-form-item label="名称(必填)">
                            <el-input v-model="storeInfoObj.store_name" placeholder="请输入门店名称"></el-input>
                        </el-form-item>
                        <el-form-item label="类型(必填)" prop="templates" class="a_modal">
                            <el-select v-model="storeInfoObj.key"
                                       placeholder="选择门店所属的类型">
                                <el-option v-for="item in storeTypeArray" :key="item.key"
                                           :label="item.value1"
                                           :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="编码">
                            <el-input v-model="storeInfoObj.store_code" placeholder="请输入门店编码"></el-input>
                        </el-form-item>
                        <el-form-item label="所属省份(必选)" prop="templates" class="a_modal">
                            <el-select v-model="storeInfoObj.province_id"
                                       placeholder="请选择门店所属的省份" @change="handleChange">
                                <el-option v-for="item in provincesArray" :key="item.province_id"
                                           :label="item.province_name"
                                           :value="item.province_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属城市(必选)" class="a_modal">
                            <el-select v-model="storeInfoObj.city_id"
                                       placeholder="请选择门店所属的城市">
                                <el-option v-for="item in cityArray" :key="item.city_id"
                                           :label="item.city_name"
                                           :value="item.city_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="地址(必填)">
                            <el-input v-model="storeInfoObj.address" placeholder="请输入门店的地址"></el-input>
                        </el-form-item>
                        <el-form-item label="邮编">
                            <el-input v-model="storeInfoObj.postcode" placeholder="请输入门店的邮政编码"></el-input>
                        </el-form-item>
                        <el-form-item label="电话">
                            <el-input v-model="storeInfoObj.telephone" placeholder="请输入门店的联系电话"></el-input>
                        </el-form-item>
                        <el-form-item label="门店等级" class="a_modal">
                            <el-select v-model="storeInfoObj.segment_id"
                                       placeholder="请选择门店的等级">
                                <el-option v-for="item in rankArray" :key="item.segment_id"
                                           :label="item.segment_name"
                                           :value="item.segment_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="门店星级">
                            <el-rate
                                    class="rate"
                                    v-model="storeInfoObj.stars"
                                    void-color="#ff9900"
                                    text-color="#ff9900">

                            </el-rate>
                        </el-form-item>

                        <el-form-item label="所属区域" class="a_modal">
                            <el-select v-model="storeInfoObj.sales_region" placeholder="请选择区域">
                                <el-option
                                        v-for="item in areaArray"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key">
                                    <span style="float: left">{{ item.value1}}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="销售主管(必选)" class="a_modal">
                            <el-select v-model="user_id" filterable multiple placeholder="请选择"
                                       @change="handleUserChange">
                                <el-option v-for="item in directorArray" :key="item.user_id"
                                           :label="item.last_name"
                                           :value="item.user_id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <!--<el-form-item label="启用">-->
                            <!--<el-switch-->
                                    <!--v-model="storeInfoObj.status"-->
                                    <!--active-color="#13ce66"-->
                                    <!--inactive-color="#ff4949">-->
                            <!--</el-switch>-->
                        <!--</el-form-item>-->

                    </el-form>

                </div>
            </el-col>
            <el-col :span="2"></el-col>
        </el-row>

    </div>
</template>

<script>
    import http from '../../../APIService/http'
    import {bus} from '../../../router/index.js'

    import {AMapManager} from "vue-amap"

    let amapManager = new AMapManager();

    export default {

        data() {
            let self = this;
            return {
                loading: false,
                isAdmin: false,
                active: 1,
                amapManager,
                zoom: 8,
                showSearch: false,
                center: [116.46, 39.92],
                result: [],
                // markers: [
                //     {
                //         position: [116.46, 39.92],
                //         visible: true,
                //         template: '1'
                //     }
                // ],
                plugin: [{
                    pName: 'Scale'
                },
                    {
                        pName: 'Geolocation',//定位插件
                        showMarker: false,
                        events: {
                            init(o) {
                                //定位成功 自动将marker和circle移到定位点
                                o.getCurrentPosition((status, result) => {
                                    self.zoom = 16
                                    // self.center = [result.position.lng, result.position.lat]
                                    self.startSearch()
                                });
                            }
                        }
                    }
                ],
                searchKey: '',
                map:null,
                poiPicker:null,
                storeInfoObj: {
                    store_name: ''
                },
                searchOption: {
                    // city: '上海',
                    // citylimit: true
                },
                edit_markers:
                    {
                        position:[],
                        events: {
                            dragend: (e) => {//拖拽结束

                                // this.center = [e.lnglat.lng, e.lnglat.lat];

                                this.storeInfoObj.lat = e.lnglat.lat
                                this.storeInfoObj.lng = e.lnglat.lng
                            }
                        },
                        visible: true,
                    },
                user_id: [],
                storeTypeArray: [],
                provincesArray: [],
                cityArray: [],
                rankArray: [],
                areaArray: [],
                directorArray: [],
            }
        },
        created() {

            let user = this.$store.getters.getUser
            // if (user.role === 'admin') {
            //     this.isAdmin = true
            // }
            this.getStoreInfoAttribute();
            this.getProvincesData();

            bus.$off('action_addStoreInfo');
            bus.$on('action_addStoreInfo', (value) => {

                this.saveStoreInfo()

            })

            //新增门店初始化
            bus.$off('action_addStoreDialog');
            bus.$on('action_addStoreDialog', (value) => {

                this.active = 1

            })


        },
        components: {},
        computed: {},
        watch: {
            searchKey() {
                if (this.searchKey === '') {
                    this.poiPicker.clear();
                }
            }
        },
        methods: {
            startSearch() {

                let vm = this;
                let map = this.amapManager.getMap();
                vm.showSearch = true;

                AMapUI.loadUI(['misc/PoiPicker'], function(PoiPicker) {
                    var poiPicker = new PoiPicker({
                        input: 'search', //输入框id
                        placeSearchOptions: {
                            map: map,
                            pageSize: 10
                        },//地点搜索配置
                        suggestContainer:'searchTip',//输入提示显示DOM
                        searchResultsContainer:'searchTip'//搜索结果显示DOM
                    });
                    vm.poiPicker=poiPicker;
                    //监听poi选中信息
                    poiPicker.on('poiPicked', function(poiResult) {

                        let source = poiResult.source;
                        let poi = poiResult.item;
                        if (source !== 'search') {
                            poiPicker.searchByKeyword(poi.name);
                        } else {
                            poiPicker.clearSearchResults();


                            // vm.showSearch=false;

                            vm.searchKey = '';
                            // vm.center = [data.data.location.lng, data.data.location.lat];

                            vm.isAdmin = true
                            vm.active = 2
                            vm.storeInfoObj.store_name = poi.name
                            vm.storeInfoObj.province_id = poi.pcode
                            vm.getCityData(poi.pcode)
                            // vm.storeInfoObj.city_id = poi.citycode
                            vm.storeInfoObj.address = poi.address
                            vm.storeInfoObj.telephone = poi.tel
                            vm.storeInfoObj.website = poi.website
                            vm.storeInfoObj.lat = poi.location.lat
                            vm.storeInfoObj.lng = poi.location.lng
                            vm.storeInfoObj.status = true

                            vm.center = [poi.location.lng,poi.location.lat];

                        }
                    });


                })

            },
            handleSearch() {

                if (this.searchKey) {
                    this.poiPicker.searchByKeyword(this.searchKey);
                }
            },
            onSearchResult(pois) {
                // let latSum = 0;
                // let lngSum = 0;
                // if (pois.length > 0) {
                //     pois.forEach(poi => {
                //         let {lng, lat} = poi;
                //         lngSum += lng;
                //         latSum += lat;
                //         this.markers.push([poi.lng, poi.lat]);
                //     });
                //     let center = {
                //         lng: lngSum / pois.length,
                //         lat: latSum / pois.length
                //     };
                //     this.mapCenter = [center.lng, center.lat];
                // }

                alert("123")

                // this.result = pois
            },
            async saveStoreInfo() {
                try {

                    if (!this.storeInfoObj.store_name) {
                        this.error('名称不能为空')
                        return
                    }

                    if (!this.storeInfoObj.key) {
                        this.error('类型不能为空')
                        return
                    }

                    if (!this.storeInfoObj.province_id) {
                        this.error('省份不能为空')
                        return
                    }

                    if (!this.storeInfoObj.city_id) {
                        this.error('城市不能为空')
                        return
                    }

                    if (!this.storeInfoObj.address) {
                        this.error('地址不能为空')
                        return
                    }

                    if (this.user_id.length === 0) {
                        this.error('请至少选择一名销售主管')
                        return
                    }


                    this.loading = true

                    var user = this.$store.getters.getUser

                    let data = {
                        tenant_id: user.tenant_id,
                        store_code: this.storeInfoObj.store_code,
                        store_name: this.storeInfoObj.store_name,
                        store_type: this.storeInfoObj.key,
                        province_id: this.storeInfoObj.province_id,
                        city_id: this.storeInfoObj.city_id,
                        county_id: '',
                        address: this.storeInfoObj.address,
                        postcode: this.storeInfoObj.postcode,
                        telephone: this.storeInfoObj.telephone,
                        area_sqm: '0',
                        website: this.storeInfoObj.website,
                        status: 'ACTIVE',
                        comments: '',
                        photo_id: '',
                        segment_id: this.storeInfoObj.segment_id,
                        region: this.storeInfoObj.sales_region,
                        stars: this.storeInfoObj.stars ? this.storeInfoObj.stars:0,
                        lat: this.storeInfoObj.lat,
                        lng: this.storeInfoObj.lng,
                        location_address: this.storeInfoObj.address ? this.storeInfoObj.address : '',
                        location_name: this.storeInfoObj.store_name ? this.storeInfoObj.store_name : '',
                        zoom: '',
                        user_id: this.user_id
                    }

                    let dataObj = {
                        service_id:'r365_server',
                        username:user.username,
                        token:'f3aef14f-a44d-4a76-8b39-6088d527be4f',
                        data:data
                    }

                    await http.post('/wapi/v1/addStore', dataObj).then(res => {

                        if (res.success) {
                            this.$message({message: '保存成功', type: 'success'});
                        } else {
                            this.$message({message: res.message, type: 'error'});
                        }

                        this.loading = false
                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            async getStoreInfoAttribute() {
                try {

                    var user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                    }
                    await http.post('/wapi/v1/getStoreInfoAttribute', data).then(res => {

                        this.storeTypeArray = res.data.storeTypeArray
                        this.rankArray = res.data.segmentArray
                        this.areaArray = res.data.regionArray
                        this.directorArray = res.data.ouArray

                    })
                } catch (err) {
                    this.error()
                }
            },
            async getProvincesData() {
                try {

                    let data = {}
                    await http.post('/wapi/v1/getProvincesData', data).then(res => {

                        this.provincesArray = res.data

                    })
                } catch (err) {
                    this.error()
                }
            }, async getCityData(province_id) {
                try {

                    let data = {
                        province_id: province_id
                    }
                    await http.post('/wapi/v1/getCityData', data).then(res => {

                        this.cityArray = res.data

                    })
                } catch (err) {
                    this.error()
                }
            },
            handleUserChange(value) {
                this.user_id = value
            },
            handleChange(value) {
                this.storeInfoObj.city_id = ''
                this.getCityData(value)
            },
            handleClose(done) {
                this.fileObj.fileList = []
                this.dialogVisible = false
//                this.$confirm('确认关闭？')
//                    .then(_ => {
                done();
//                    })
//                    .catch(_ => {});
            },
            handleSearch() {
                if (this.searchKey) {
                    this.placeSearch.search(this.searchKey);
                }
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';

    .container {

        .map {
            width: 100%;
            margin: -20px 0 20px 0;
        }
    }
</style>
<style scoped>
    .subjectList >>> .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }

    .rate >>> .el-rate__icon {
        font-size: 32px;
    }

    .a_modal >>> .el-select {
        width: 100%;
    }

    .amap-page-container {
        height: 300px;
        position: relative;
    }

    .search-box {
        position: absolute;
        z-index: 5;
        width: 35%;
        left: 30px;
        top: 10px;
        height: 32px;
    }

    .search-box input {
        float: left;
        width: 80%;
        height: 100%;
        border: 1px solid #38f;
        padding: 0 8px;
    }

    .search-box button {
        float: left;
        width: 14%;
        height: 32px;
        background: #38f;
        border: 1px solid #38f;
        color: #fff;
    }

    .tip-box {
        width: 100%;
        max-height: 260px;
        position: absolute;
        top: 30px;
        overflow-y: auto;
        background-color: #fff;
    }

</style>



// WEBPACK FOOTER //
// src/pages/stores/storesInfo/searchStoreItem.vue